import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';

export const useRoutingCardsStyles = createStyles(({ token }) => ({
  routingCard: {
    '&&': {
      minHeight: 70,

      '.ant-card-body': {
        boxShadow: `0 -2px 0 0 ${token.colorWhite}, 0 1px 0 0 ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.2)}, 1px 1px 6px 0 ${ThemeColors.COLOR_GREY8_1}`,
        borderRadius: token.borderRadiusSM,
        backgroundColor: ThemeColors.COLOR_GREY10,
      },

      '&&& .ant-card-body': {
        padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
      },
    },
  },

  routingCardRecommended: {
    '&&& .ant-card-body': {
      backgroundColor: token.colorWhite,
    },
  },

  routingCardContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  routingCardAirports: {
    fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
    fontWeight: 400,
    marginTop: ThemeSpaces.SPACE_XXS,
  },

  selectButton: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    '.ant-btn.ant-btn-primary': {
      height: 18,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      fontWeight: 700,
      borderRadius: token.borderRadiusSM,
      lineHeight: '16px',
      marginTop: ThemeSpaces.SPACE_XXS,
    },
  },

  routingCardBadge: {
    borderRadius: 11,
    backgroundColor: hexToRgbaWithAlpha(ThemeColors.COLOR_ORANGE3, 0.5),
    color: ThemeColors.COLOR_BROWN2,
    fontFamily: token.fontFamily,
    fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
    fontWeight: 700,
    padding: `2px ${ThemeSpaces.SPACE_SM}px`,
    marginBottom: 7,
    marginTop: -5,
    marginRight: ThemeSpaces.SPACE_NORM0_5,
  },

  quoteRoutingTopCard: {
    '&&': {
      boxShadow: `1px 3px 8px 0 ${ThemeColors.COLOR_GREY_BLUISH3}`,
      borderRadius: token.borderRadiusSM,
      overflow: 'hidden',
      height: 140,

      '.SimpleCard-Body': {
        padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
        backgroundColor: ThemeColors.COLOR_WHITE2,
        borderRadius: token.borderRadiusSM,
        height: '100%',
      },

      '.SimpleCard-Header h4': {
        fontSize: '18px !important',
      },
    },
  },

  quoteRoutingTopCardRowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: ThemeColors.COLOR_GREY_DARK0_8,
    fontFamily: token.fontFamily,
    fontSize: token.fontSize,
    fontWeight: 500,
  },

  labelDate: {
    color: ThemeColors.COLOR_GREY_BLUISH,
    fontSize: ThemeFont.FONT_SIZE_XS,
    fontWeight: 400,
    marginTop: ThemeSpaces.SPACE_NORM,
  },

  labelTime: {
    color: ThemeColors.COLOR_BLACK3,
    fontSize: token.fontSizeSM,
    fontWeight: 500,
  },

  waypointHorizontalWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    marginLeft: ThemeSpaces.SPACE_NORM_50,
    marginRight: ThemeSpaces.SPACE_NORM_50,

    '.far, .fas': {
      color: token.colorPrimary,
    },
  },

  waypointLineHorizontal: {
    position: 'absolute',
    left: 0,
    right: 0,
    borderTop: `1px dashed ${ThemeColors.COLOR_GREY12}`,
    top: '50%',
    transform: 'translateY(-50%)',
    marginLeft: ThemeSpaces.SPACE_NORM_15,
    marginRight: ThemeSpaces.SPACE_NORM_15,
  },

  flightsDatesRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: ThemeSpaces.SPACE_NORM_20,
    paddingLeft: ThemeSpaces.SPACE_NORM_20,
  },

  flightsTimesRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
  },

  routingStopsList: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-around',
    left: 0,
    right: 0,
    top: -1,

    '.fas': {
      fontSize: ThemeFont.FONT_SIZE_20,
      color: ThemeColors.COLOR_GREY12,
    },
  },
}));
